module.exports = __webpack_public_path__ + "segment-2-22c1186d213d95e545deb373c1ba645b.webp";